import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { useButtonContext } from './ButtonContext.js';

function ButtonText({ children }) {
    const { size } = useButtonContext();
    return jsx(ButtonTextWrapper, { "$size": size, children: children });
}
const ButtonTextWrapper = styled("div")(({ theme, $size }) => (Object.assign({ padding: theme.spacing(0, 1) }, ($size === "sm" && {
    padding: theme.spacing(0, 0.5),
}))));

export { ButtonText };
//# sourceMappingURL=ButtonText.js.map
